module.exports = `<div class="cap-step-container" id="step-<%= id %>">
	<h2 class="cap-title"><%= name %></h2>
	<button type="button" class="button button--blue-light button--small clear-step-button">Clear Selection<%= typeof allow_multiple !== 'undefined' && allow_multiple ? 's' : '' %></button>
	<button type="button" class="button button--blue-light button--small next-step-button">Continue &gt;</button>

	<%- categoriesHTML %>

  <p class="cap-step-footnote"><%= description %></p>
</div>
`